import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";
import BoosterHeaderBrandingMobile from "../booster-header-branding-mobile/component";
import LanguageButton from "../language-button/component";
import {dataRegister} from "../../services/dataRegister";
import BoosterProperty from "../booster-property/component";

class BoosterHeaderBranding extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            user: {},
            lang: null,
            temp_lang: null,
            language: false,
            dropdown: false,
            signup: false,
            leave: false,
            home: false,
            profile: false,
            languages: [],
            logout: false,
            private: false
        };
    };

    componentWillMount() {
    }

    componentDidMount() {
        this.setState({
            lang: this.props.lang,
            market: this.props.market,
            website: this.props.website,
            logo: this.props.logo,
            favicon: this.props.favicon
        })
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market
        })
    }

    _openMenu() {
        this.child._openMenu();
    }

    _renderText(item) {
        return langRegister.get("signup-header-one", item, this.state.lang);
    }

    render() {
        return (
            <div>
                <div className={Styles.header}>
                    <div className={Styles.logoContainer}>
                        {
                            <a href={"https://" + this.state.website + "?utm_source=" + salesChannelRegister.get('name')} target={'_blank'}>
                                <img className={Styles.logoContainerIcon} src={this.state.logo}/>
                            </a>
                        }
                        {
                            <a href={"https://" + this.state.website + "?utm_source=" + salesChannelRegister.get('name')} target={'_blank'}>
                                <img className={Styles.logoContainerIconMobile} src={this.state.favicon}/>
                            </a>
                        }
                    </div>
                    <div className={Styles.menuContainer}>
                    </div>
                    {
                        <div className={Styles.buttonContainer}>
                            <div className={Styles.languageButtonContainer}>
                                <LanguageButton history={this.props.history} market={this.state.market}
                                                lang={this.state.lang}/>
                            </div>
                            {
                                <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                                     src={require('../../assets/images/menu_icon.svg')}/>
                            }
                        </div>
                    }
                    <BoosterHeaderBrandingMobile history={this.props.history} market={this.state.market} lang={this.state.lang} website={this.state.website} favicon={this.state.favicon}
                                         props={this.props.props} ref={instance => {
                        this.child = instance
                    }} layout={true}/>
                </div>
            </div>
        );
    }
}

export default BoosterHeaderBranding;


// WEBPACK FOOTER //
// ./src/components/booster-header-branding/component.js